import { render } from "./view-purchase-order.vue?vue&type=template&id=1c31c572&scoped=true"
import script from "./view-purchase-order.vue?vue&type=script&lang=js"
export * from "./view-purchase-order.vue?vue&type=script&lang=js"

import "./view-purchase-order.vue?vue&type=style&index=0&id=1c31c572&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c31c572"]])

export default __exports__